export default __webpack_public_path__ + "static/11-bakwagen-20m3-8ea1c3ed814978ca3885a2f4ec275917.webp";